<template>
  <div class="block portal__content claim__list">
    <claim-list-item v-for="claim in listedClaims" :key="claim.Id" :claim="claim"></claim-list-item>
    <div class="claim__item" v-if="this.claimlist('managedclaims').length === 0 && this.claimlist('claims').length === 0">
      <div class="claim__content">
        <h3 v-show="busy">{{ getUiString(['claim_list','loading_claims']) }}</h3>
        <h3 v-show="!busy">{{ getUiString(['claim_list','no_claims_found']) }}</h3>
      </div>
    </div>
    <div class="split-content">
      <a class="button button--sec button--icon" v-bind:href="claimUrl">
        <span>{{ getUiString(['claim_list','submit_claim']) }}</span>
        <lennoc-icon image="plus" domClass="icon--add" />
      </a>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ClaimListItem from '@/components/claims/ClaimListItem.vue'
import { cultureCheck } from '@/utils/cultureCheck'

export default {
  name: 'ClaimsListView',
  components: {
    ClaimListItem
  },
  beforeMount () {
    this.$store.dispatch('refreshDossier')
  },
  mounted () {
    if (this.hasOnlyManagedClaims === true) {
      this.$router.push('/home/managedclaims')
    }
  },
  computed: {
    ...mapGetters({
      getUiString: 'uistrings/getUiString',
      claimlist: 'dossier/getClaimList',
      getIsBusy: 'dossier/getIsBusy'
    }),
    listedClaims () {
      return this.$route.name === 'managedclaims'
        ? this.claimlist('managedclaims')
        : this.claimlist('claims')
    },
    hasOnlyManagedClaims () {
      if (this.claimlist('managedclaims').length > 0 && this.claimlist('claims').length === 0) {
        return true
      }
      return false
    },
    busy () {
      return this.getIsBusy
    },
    claimUrl () {
      return cultureCheck().includes('nl')
        ? '/check-uw-vlucht'
        : cultureCheck().includes('de')
          ? '/pruefen-sie-ihren-flug'
          : '/free-flight-check'
    }
  }
}
</script>
